import { Auth } from "aws-amplify";

export async function getToken() {
  return await Auth.currentSession()
    .then((res) => {
      const accessToken = res.getIdToken();
      return accessToken.getJwtToken();
    })
    .catch((error) => {
      // if an error is  triggered then undefined is returned >> trigger normal auth flow
      // Could also throw a 'session has been lost' and trigger a sign out function
      console.error(error);
      return "";
    });
}
